
export class TemplateModel {

  constructor(
    public name: string,
    public label: string,
  ) { }
}

export class TemplatePriorityModel {
  constructor(
    public template_name: string,
    public template_display_label: string,
    public event_types?: string[],
    public priority?: string,
    public switcher?: Array<any>,
    public customizations?: Array<CustomPriorityByEventType>,
    public old_priority?: string,
  ) { }
}

export class EventTypeModel {

  constructor(
    public code: string,
    public label: string,
  ) { }
}

export class TemplatePriorityExportRequest {
  constructor(
    public export_type: string,
    public opp_list: Array<TemplatePriorityExportOppItem> | string
  ) { }
}

export class TemplatePriorityExportOppItem {
  constructor(
    public product_id: string,
    public product_display_label: string,
    public program_id: string,
    public program_display_label: string,
    public operator_id: string,
    public operator_display_label: string
  ) { }
}

export class TemplatePriorityExportResponse {
  constructor(
    public code: number,
    public message: string,
    public sheets: Array<string>
  ) { }
}

export interface CustomPriorityByEventType {
  event_type: string,
  priority: string
}

export interface SaveTemplatePriorityRequest {
  template_name: string,
  event_type: string,
  priority: string,
  product_id: string,
  logged_info?: Array<TemplatePriorityLog>
}

export interface TemplatePriorityLog {
  username: string,
  user_id: string,
  template_name: string,
  old_priority: string,
  new_priority: string,
}